/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Style_Guide_Manager_Min_Event_Gap_LabelInputs */



/**
* | output |
* | --- |
* | "Minimum Event Gap" |
*
* @param {Style_Guide_Manager_Min_Event_Gap_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const style_guide_manager_min_event_gap_label = /** @type {((inputs?: Style_Guide_Manager_Min_Event_Gap_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Style_Guide_Manager_Min_Event_Gap_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Ecart d'evenement minimum")
	if (locale === "de") return /** @type {LocalizedString} */ ("Mindestereignisabstand")
	if (locale === "it") return /** @type {LocalizedString} */ ("Gap minimo dell'evento")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Минимальный разрыв между событиями")
	if (locale === "es") return /** @type {LocalizedString} */ ("Brecha mínima de eventos")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("最小事件间隔")
	if (locale === "ja") return /** @type {LocalizedString} */ ("最小イベントギャップ")
	if (locale === "hi") return /** @type {LocalizedString} */ ("न्यूनतम घटना अंतराल")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Intervalo mínimo entre eventos")
	return /** @type {LocalizedString} */ ("Minimum Event Gap")
});